import { MakeStringValues, Translations } from "../translations.type";

export const esTranslations: MakeStringValues<Translations> = {
  "Trascina qui un'immagine o clicca per caricarne una!": "",
  "Registra una nuova attivit\u00E1!": "",
  Annulla: "Cancelar",
  Aggiungi: "Agregar",
  Banner: "Banner",
  Testi: "Textos",
  Orari: "Horarios",
  "Banner dell'evento": "Cartel de evento",
  Titolo: "Título",
  Contenuto: "Contenido",
  "Data di inizio": "Fecha de inicio",
  "Fino al": "Hasta el",
  "Crea Evento": "Crear evento",
  Applica: "Solicitar",
  Nome: "Nombre",
  Gestione: "Gestión",
  "Log out": "Cerrar sesión",
  "Crea una promozione di benvenuto!": "¡Crea una promoción de bienvenida!",
  "Durata promozione": "Duración de la promoción",
  Anteprima: "Avance",
  Modifica: "Editar",
  "Giorni alla scadenza": "Días por vencer",
  Crea: "Crear",
  "Ore alla scadenza": "Horas por vencer",
  "Minuti alla scadenza": "Minutos por vencer",
  Descrizione: "Descripción",
  "Descrizione:": "Descripción:",
  Salva: "Salvar",
  "Data di fine": "Fecha final",
  Chiudi: "Cerrar",
  "Breve descrizione della promozione": "Breve descripción de la promoción.",
  " Minuti": " Minutos",
  " Giorni ": " Días",
  " Ore ": " Horas",
  Scadenza: "Vencimiento",
  "Valida fino al giorno ": "Válido hasta el día ",
  "Qui ci sar\u00E1 la descrizione del tuo negozio, puoi modificarla nel pannello amministrativo!":
    "Aquí estará la descripción de tu tienda, puedes cambiarla en el panel de administración!",
  Gestisci: "Administrar",
  "filtra tipologia": "tipo de filtro",
  Tutte: "Todos",
  Test: "Test",
  Produzione: "Producción",
  "Invia una notifica": "Enviar una notificación",
  "Nuova notifica": "Nueva notificación",
  "Messaggio notifica": "Mensaje de notificación",
  "Codice di verifica": "Código de verificación",
  "Conferma!": "Confirmación!",
  "Registrandoti accetti i nostri": "Registrandoti accetti i nostri",
  "termini di servizio": "termini di servizio",
  "privacy policy": "privacy policy",
  "Iniziamo!": "Empezamos!",
  "Sei gi\u00E1 registrato?": "Eres ya registrado?",
  Accedi: "Login",
  "Devices Subscribed And Reached": "Devices Subscribed And Reached",
  "Confirm code!": "Confirm code!",
  "Entra!": "Entrar!",
  "Non hai ancora un account?": "Aún no tienes una cuenta?",
  Registrati: "Registrate",
  "Come Funziona": "Como Funciona",
  Prezzi: "Precios",
  // HomePage
  "Fai crescere la tua attivit\u00E0 con Adhesion":
    "Haz crecer tu negocio con Adhesion",
  "Richiama istantaneamente i tuoi clienti e offri loro le tue promozioni":
    "Llame al instante a sus clientes y ofrezca sus promociones",
  "Inizia subito": "Empieza ahora",
  // HeroSections
  "Notifica i tuoi clienti quando crei le tue promozioni":
    "Notifica a tus clientes cuando creas tus promociones",
  "Adhesion sfrutta la tecnologia delle notifiche push per avvisare i tuoi clienti e offrire loro sconti e agevolazioni":
    "Adhesion aprovecha la tecnolog\u00EDa de notificaciones push para alertar a tus clientes y ofrecerles descuentos y beneficios",
  "Raddoppia le vendite gi\u00E0 dal primo mese di utilizzo":
    "Duplica tus ventas desde el primer mes de uso",
  "Adhesion \u00E8 un'app nativa in abbonamento senza vincoli di tempo adatta ad ogni tipo di attivit\u00E0 commerciale":
    "Adhesion es una aplicaci\u00F3n de suscripci\u00F3n nativa sin limitaciones de tiempo adecuada para cualquier tipo de actividad comercial",
  "Parti col piede giusto": "Empieza con buen pie",
  "Adhesion \u00E8 in super promozionale iniziale e totalmente gratuito, ma non lo sar\u00E0 per sempre! Registrandoti ora diventerai un affiliato gratuito per sempre!":
    "Adhesión está en una súper promoción inicial y es totalmente gratis, ¡pero no será para siempre! ¡Al registrarse ahora, se convertirá en un afiliado gratuito para siempre!",
  // HowSection
  "Richiedi informazioni": "Solicitar informacion",
  instruction1:
    "Regístrate ahora <1>sin costo</1> y empieza a descargar la aplicaci\u00F3n para tus clientes de inmediato.",
  instruction2:
    "Lee el breve manual de usuario y crea tu base de usuarios. Sigue nuestro <1>manual de marketing</1> y desarrolla promociones atractivas para sus clientes.",
  instruction3:
    "Analiza las <1>estad\u00EDsticas semanales</1> de Adhesion para ver qu\u00E9 promociones fueron percibidas como m\u00E1s interesantes por tus clientes.",
  instruction4:
    "<1>Compare la facturaci\u00F3n</1> de su empresa antes y despu\u00E9s de usar Adhesion.",
  "Piani mensili proposti": "Planes y Precios",
  mese: "mes",
  promos: "1 promoci\u00F3n por semana",
  promos_plural: "{{count}} promociones por semana",
  devices: "1 dispositivo",
  devices_plural: "{{count}} dispositivos",
  notis: "1 notificaci\u00F3n por semana",
  notis_plural: "{{count}} notificaciones por semana",
  "Domande frequenti": "Preguntas frecuentes",
  "Ti ricontatteremo subito": "Te contactaremos de inmediato",
  // Contact form
  Email: "Correo",
  Telefono: "Tel\u00E9fono",
  "\u002AFacolatativo": "\u002AOpcional",
  "Voglio saperne di pi\u00F9": "Quiero saber m\u00E1s",
  "Le tue attivit\u00E0": "Tus actividades",
  "\u00C8 disponibile una nuova versione!":
    "Una nueva version esta disponible!",
  Aggiorna: "Actualizar",
  "Sei attualmente offline. L'accesso all'applicazione potrebbe essere limitato.":
    "Actualmente está desconectado. El acceso a la aplicación puede estar restringido.",
  "Torna online per scaricare nuovi dati":
    "Vuelva a conectarse para descargar nuevos datos",
  Generali: "Generales",
  "Cerca tra i tuoi eventi con codice QR di attivazione":
    "Busca tus eventos con código QR de activación",
  "Verifica codice QR": "Verificar código QR",
  Eventi: "Eventos",
  "Centro Notifiche": "Centro de notificaciones",
  Statistiche: "Estadísticas",
  Profilo: "Perfil",
  Inizia: "Inicio",
};
